import React, { useState } from 'react';
import './Page.css';
import ContactModal from '../components/ContactModal';

const Rentals = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const rentalService = {
    id: 'equipment-rentals',
    title: 'Porta John Rentals',
    customMessage: 'I am interested in renting equipment from All Around Septic Pumping, LLC.\n\nPlease provide me with more information about your rental options, availability, and pricing.'
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Porta John Rentals</h1>
        <p className="page-subtitle">Quality equipment for your projects</p>
      </div>

      <div className="content-section">
        <div className="rentals-grid">
          <div className="rental-card">
            <h3>Portable Toilets</h3>
            <p>Clean, well-maintained portable restroom facilities for events and construction sites.</p>
            <ul className="rental-features">
              <li>Various sizes available</li>
              <li>Regular maintenance included</li>
              <li>Delivery and pickup service</li>
            </ul>
          </div>
        </div>

        <div className="cta-section">
          <h2>Need Equipment?</h2>
          <p>Contact us to discuss your rental needs and get a quote.</p>
          <button onClick={openModal} className="cta-button">Contact Us</button>
        </div>
      </div>

      {isModalOpen && (
        <ContactModal
          service={rentalService}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default Rentals;

